import React, { useState } from "react";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const MobileSubMenu = ({
  isChild,
  icon,
  name,
  onClose,
  path,
  style,
  toggle,
  fullMenu,
}) => {
  // const [open, setOpen] = useState(false);
  // console.log(isChild)
  // console.log(fullMenu)
  return (
    <>
      <li>
        <a onClick={toggle} style={{display:'flex',justifyContent:"space-between"}}>
          <span>
            {/* <i className={icon}></i> */}
            {icon}
          </span>
          {fullMenu ? name : <>&nbsp;</>}
          {fullMenu && (
            <label >
              <i
                className={
                  style === path ? "fa fa-caret-down" : "fa fa-caret-right"
                }
              ></i>
            </label>
          )}
        </a>
        <Collapse in={style === path} timeout="auto" unmountOnExit>
          <div className="sub-menu">
            <ul>
              {isChild &&
                isChild
                  // .filter((child) => child.enabled)
                  .map((child) => {
                    return (
                      <li  className="" key={child.path}>
                        <NavLink
                          to={child.path}
                          style={{paddingLeft:"50px"}}
                          onClick={() => onClose && onClose(false)}
                        >
                          <span style={{marginLeft:"10px"}}>
                            {/* <i className={child.icon}></i> */}
                            <NavigateNextIcon fontSize="small" />
                          </span>
                          {fullMenu ? child.name : <>&nbsp;</>}
                        </NavLink>
                      </li>
                    );
                  })}
            </ul>
          </div>
        </Collapse>
      </li>
    </>
  );
};

export default MobileSubMenu;
